import { CsvFileKind } from "../../modes/define/CsvFileKind";
import { FileKind } from "../../modes/define/FileKind";
import O1HD from "../gameEngine";
import BaseSingle from "../libs/BaseSingle";
import data_control from "../libs/data_control";
import utilsModel from "../libs/utilsModel";

export default class CsvDataManage extends BaseSingle {

    static get instance() {
        return super.GetInstance<CsvDataManage>();
    }

    gameCsvData: any = {};

    async initCsvList(loadBack?: (progress: number)=>void, loadFinish?: ()=> void) {
        return new Promise<void>(resolve=> {
            let CsvFile = CsvFileKind.CsvFile;
            let csvFile = [
                CsvFile.LEVEL,
                // CsvFile.LEGAL_CASE_CONFIG,
                // CsvFile.LEGAL_CASE_PEOPLE,
                // CsvFile.LEGAL_CASE_PEOPLE_ARRAY,
                // CsvFile.LEGAL_CASE_PRIMARY,
                // CsvFile.LEGAL_CASE_PRIMARY_STEP,
                // CsvFile.LEGAL_CASE_PRIMARY_EXHIBIT,
                // CsvFile.LEGAL_CASE_PRIMARY_ACTION,
                // CsvFile.LEGAL_CASE_MAIN,
                // CsvFile.LEGAL_CASE_SPECIAL,
                // CsvFile.EXAM_QUESTION_BANK,
                CsvFile.FIRST_ENTER_LAYER,
                CsvFile.FIRST_ENTER_EVENT,
                CsvFile.FIXED_TIME_EVENT_ARR,
                CsvFile.FIXED_TIME_EVENT,
                CsvFile.RANDOM_EVENT_ARR,
                CsvFile.RANDOM_EVENT,
                CsvFile.MAIN_EVENT_ARRAY,
                CsvFile.MAIN_EVENT,
				CsvFile.UPGRADE_EVENT,
                CsvFile.UPGRADE_EVENT_ARR,
                CsvFile.TASK_LIST,
                CsvFile.CITY,
                CsvFile.OFFICER,
                CsvFile.PAWN,
                CsvFile.MATCH_MIAI,
                CsvFile.ESCORT_GOODS1,
                CsvFile.MANSION,
                CsvFile.MANSION_BUILD,
                CsvFile.CHILD_INTIMACY,
                CsvFile.WIFE_INTIMACY,
                CsvFile.WIFE,
                CsvFile.MANSION_CARD,
                CsvFile.THRU_TIME_LEVEL,
                CsvFile.SHIP,
                CsvFile.ORCHARD,
            ];

            let csvMapFile: string[] = [
                // CsvFile.LEGAL_CASE_MAIN_ATTRIBUTE,
                // CsvFile.EXAM_QUESTION_BANK,
            ];

            let csvFileIndx = 0;
            let csvFileLength = csvFile.length;
            for (let file of csvFile){
                this.loadCsvFile(file, false, ()=> {
                    csvFileIndx++;
                    if (loadBack) {
                        loadBack(csvFileIndx / csvFileLength);
                    }
                    if (csvFileLength <= csvFileIndx) {
                        // 加载完成
                        if (loadFinish) {
                            loadFinish();
                        }
                        resolve();
                    }
                });
            }

            for (let file of csvMapFile){
                this.loadCsvFile(file, true);
            }
        });
    }

    loadCsvFile(filePath: string, bFirstMap: boolean = false, onComplete?: ()=>void) {
        let bundle =  O1HD.getModules().uiControlModule.getGameBundle();
        utilsModel.readCsvData(bundle, filePath, (_data)=>{
            let data = {};
            data['title'] = {}
            
            for (let i in _data[1]){
                data['title'][_data[1][i]] = i;
            }

            let idIndex = data['title'].id ?? 0;
            for(let i = 2; i < _data.length; i++){

                if (bFirstMap) {
                    if (!data[_data[i][idIndex]]) {
                        data[_data[i][idIndex]] = [];
                    }
                    data[_data[i][idIndex]].push(_data[i]);
                } else {
                    data[_data[i][idIndex]] = _data[i];
                }
                
            }
            this.gameCsvData[filePath] = data;

            // Logger.logModel(`CSV File ${name} load Finish`);

            if (onComplete) {
                onComplete();
            }
        });
    }

    getCsvData(name: string){
        if (this.gameCsvData == null) return null;
        if (this.gameCsvData[name] == null) {
            console.warn(`此文件未加载 ${name}`);
            return null;
        }
        return this.gameCsvData[name];
    }

    resetCsvData(name: string) {
        this.gameCsvData[name] = null;
    }

    /**
     * 获取csv中的数据
     * @param csvName 文件名
     * @param id id
     * @param itemName 字段名字，null则是全部字段
     * @returns 
     */
    getCsvDataItem(csvName: string, id: number | string, itemName?: any): any {
        let _infos = this.getCsvData(csvName);
        if (!_infos){
            return null;
        }

        let result = {};
        let _title = _infos.title;
        let info = _infos[id];
        if (!info) {
            return null;
        }

        if (!itemName) {
            for (let n in _title) {
                result[n] = info[_title[n]];
            }
        } else {
            for (let o of itemName) {
                result[o] = info[_title[o]];
            }
        }
        return result;
    }

    /**
     * 根据人物组获取人物id
     * @param id 
     * @returns 
     */
    getPeopleArrayRandomId(
        id: string
    ) {
        let csvPeopleArr = this.getCsvData(CsvFileKind.CsvFile.LEGAL_CASE_PEOPLE_ARRAY);
        if (!csvPeopleArr) {
            console.error(`未读取到表格数据`);
            return null;
        }
        let title = csvPeopleArr.title;
        let info = csvPeopleArr[id];
        if (!info) {
            console.error(`未找到对应数据`);
            return null;
        }
        let list: string = info[title.list];
        let arrSplits = utilsModel.splitLineFeed(list);
        let randomIdx = 0;
        if (arrSplits.length > 1) {
            randomIdx = data_control.randomNumInt(0, arrSplits.length-1);
        }
        let region = arrSplits[randomIdx].split(FileKind.ResParseType.SUB_ITEM);
        let randomId = data_control.randomNumInt(Number(region[0]), Number(region[1]));
        return randomId + '';
    }

    getMaxLv() {
        let csvInfos = this.getCsvData(CsvFileKind.CsvFile.LEVEL);
        if (!csvInfos) {
            console.error(`未找到表格数据`);
            return null;
        }

        let maxLv = 0;
        for (let i in csvInfos) {
            if (i == 'title' || i == '' || i.trim() == '') {
                continue;
            }
            let lv = Number(i);
            if (maxLv < lv) {
                maxLv = lv;
            }
        }
        return maxLv;
    }

    /**
     * 获得经验进度数据
     * @param lv 
     * @param reputation 
     * @returns 
     */
    getExpProgressFromLv(
        lv: number
        , reputation: number
    ) {
        let csvInfos = this.getCsvData(CsvFileKind.CsvFile.LEVEL);
        if (!csvInfos) {
            console.error(`未找到表格数据`);
            return null;
        }

        let title = csvInfos.title;
        let info = csvInfos[lv];
        let infoNext = csvInfos[lv+1];
        if (!info) {
            console.error(`等级表格数据有误`);
            return null;
        }

        let curExp = Number(info[title.exp].replace(/,/g, ''));
        let totalExp = curExp;
        if (infoNext) {
            let nextExp = Number(infoNext[title.exp].replace(/,/g, ''));
            totalExp = nextExp - curExp;
            curExp = reputation - curExp;
        }
        return {
            curExp: curExp
            , totalExp: totalExp
            , bMax: infoNext ? false : true
        }
    }

    getUserUpdateLevel(exp: number) {
        let csvInfos = this.getCsvData(CsvFileKind.CsvFile.LEVEL);
        if (!csvInfos) {
            console.error(`未找到表格数据`);
            return null;
        }

        let title = csvInfos.title;
        let curLv = 1;
        for (let i in csvInfos) {
            if (i == 'title' || i == '' || i.trim() == '') {
                continue;
            }
            let info = csvInfos[i];
            let expT = info[title.exp] as string;
            expT = expT.replace(/,/g, '');
            if (exp >= Number(expT)) {
                curLv = Number(i);
            } else {
                break;
            }

        }
        // let curLv = lv;
        // while(true) {
        //     let info = csvInfos[curLv];
        //     if (!info) {
        //         console.error(`数据错误`);
        //         break;
        //     }
        //     let lvExp = Number(info[title.exp]);
        //     if (exp >= lvExp) {
        //         break;
        //     }

        //     curLv--;
        // }
        return curLv;
    }

    getCsvRandomId(csvName: string) {
        let csvInfos = this.getCsvData(csvName);
        if (!csvInfos) {
            console.error(`数据未找到`);
            return null;
        }
        
        let idArr: string[] = this.getCsvIds(csvName);
        let randomIdx = data_control.randomNumInt(0, idArr.length-1);
        let id = idArr[randomIdx];
        return id;
    }

    getCsvRandomIdArr(csvName: string, randomCount: number) {
        let csvInfos = this.getCsvData(csvName);
        if (!csvInfos) {
            console.error(`数据未找到`);
            return null;
        }

        let idArr: string[] = this.getCsvIds(csvName);

        let randomIdx = data_control.randomIntNum(0, idArr.length-1, randomCount);
        let retArr: string[] = [];
        for (let o of randomIdx) {
            retArr.push(idArr[o]);
        }
        return retArr;
    }

    getCsvIds(csvName:string){
        let csvInfos = this.getCsvData(csvName);
    
        if (!csvInfos) {
            console.error(`数据未找到`);
            return [];
        }

        let idArr: string[] = [];
        for (let i in csvInfos) {
            if (i == 'title' || i == '' || i.trim() == '') {
                continue;
            }
            idArr.push(i);
        }
        return idArr;
    }

}
